import React from "react";
import { Stack, Typography } from "@mui/material";
import useScopeAttributes from "common/hooks/useScopeAttributes";
import MarkdownEditor from "common/components/MarkdownEditor";
import SectionHeader from "common/components/SectionHeader";
import Input from "common/components/Input";
import ActionButton from "common/components/ActionButton";
import toast from "react-hot-toast";
import useFetcher from "common/hooks/useFetcher";
import { MiniLoader } from "common/components/Loader";
export default function AstroHubPublish({ id, data, onClose }) {
  const {
    tags,
    TagInput,
    loading: attrLoading,
    setInit,
  } = useScopeAttributes();
  const [description, setDescription] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [tagline, setTagline] = React.useState(data?.description || "");
  const [version, setVersion] = React.useState("1");
  const [dispatching, setDispatching] = React.useState(false);
  const [published, setPublished] = React.useState(false);
  const fetcher = useFetcher();
  const onPublish = async (close) => {
    setDispatching(true);
    let payload = { tagline, tags };
    payload.details = description;
    //validation
    if (tags.length > 3) {
      setDispatching(false);
      return toast.error("Can only have 3 tags for a published package");
    }
    if (tags.length === 0) {
      setDispatching(false);
      return toast.error("Must have at least 1 tag for a published package");
    }
    if (tagline.length < 10 || tagline.length > 50) {
      setDispatching(false);
      return toast.error("Tagline must be between 10 and 50 characters");
    }
    if (!tagline) {
      setDispatching(false);
      return toast.error("Name and Tagline must exist");
    }
    await fetcher.post(
      "publishing package",
      `/api/store/package/publish/${id}`,
      () => {
        let form = new FormData();
        form.append("json", JSON.stringify(payload));
        return form;
      },
      ({ error }) => {
        if (error) {
          toast.error(error);
          setDispatching(false);
          return setLoading(false);
        }
        toast.success("package published");
        setDispatching(false);
      },
      () => {
        setDispatching(false);
        setLoading(false);
      }
    );
    onClose();
  };
  const fetchPackage = async (id) => {
    setLoading(true);
    try {
      await fetcher.get(
        "fetching package",
        `/api/store/package/${id}`,
        ({ pkg }) => {
          if (!pkg) return;
          setPublished(true);
          setDescription(pkg.details || "");
          // setName(system.name || "");
          setVersion(`${pkg?.version}`);
          setTagline(pkg?.tagline || "");
          setInit(pkg?.tags || [], []);
        },
        () => setLoading(false)
      );
    } catch {}
    setLoading(false);
  };
  React.useEffect(() => {
    if (!id) return;
    fetchPackage(id);
  }, [id]);
  if (loading) {
    return (
      <div
        style={{
          marginTop: "50px",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <MiniLoader />
        <Typography sx={{ marginTop: "70px" }}>
          Getting ready for launch!
        </Typography>
      </div>
    );
  }
  return (
    <Stack p={2} gap={3}>
      <SectionHeader large icon="rocket_launch">
        Publish To AstroHub
      </SectionHeader>
      <Stack className="floating" gap={3}>
        {/* <Stack>
          <Typography variant="h5">Description</Typography>
        </Stack> */}
        <Stack gap={3}>
          {/* <Input
            size="small"
            dark
            label="Name"
            sx={{ width: "100%" }}
            placeholder="package name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          /> */}
          <Input
            size="small"
            dark
            label="Tagline"
            sx={{ width: "100%" }}
            placeholder="package tagline"
            value={tagline}
            onChange={(e) => setTagline(e.target.value)}
          />
          <Typography style={{ fontSize: "14px" }}>Description</Typography>
          <MarkdownEditor
            {...{ markdown: description, setMarkdown: setDescription }}
          />
          <TagInput />
        </Stack>
      </Stack>
      <div style={{ marginLeft: "auto" }}>
        <ActionButton
          icon="save"
          dark
          noload
          handler={async () => {
            await onPublish();
          }}
        >
          Publish Version {`${Number(version) + 1}`}
        </ActionButton>
      </div>
      <div style={{ height: "100px" }} />
    </Stack>
  );
}
